export default __webpack_public_path__ + "static/media/dancing-script-latin-700.3b75e97b.woff2";